import type {
  FullMenuDto,
  FullMenuInput,
  ListingMenuKind,
  ListingMenusDto,
  LunchMenuDto,
  LunchMenuInput,
} from '@pulsify/shared/dto'
import { api, unwrap } from '~/shared/lib/rpc'

export const listingMenusApi = {
  async get(businessId: string, listingId: string): Promise<ListingMenusDto> {
    const res = await api.api.businesses[':businessId'].listings[':id'].menus.$get({
      param: { businessId, id: listingId },
    })
    return unwrap<ListingMenusDto>(res)
  },

  async saveLunch(
    businessId: string,
    listingId: string,
    input: LunchMenuInput,
  ): Promise<LunchMenuDto> {
    const res = await api.api.businesses[':businessId'].listings[':id'].menus.lunch.$put({
      param: { businessId, id: listingId },
      json: input,
    })
    return unwrap<LunchMenuDto>(res)
  },

  async saveFull(
    businessId: string,
    listingId: string,
    input: FullMenuInput,
  ): Promise<FullMenuDto> {
    const res = await api.api.businesses[':businessId'].listings[':id'].menus.full.$put({
      param: { businessId, id: listingId },
      json: input,
    })
    return unwrap<FullMenuDto>(res)
  },

  async remove(businessId: string, listingId: string, kind: ListingMenuKind): Promise<void> {
    const res = await api.api.businesses[':businessId'].listings[':id'].menus[':kind'].$delete({
      param: { businessId, id: listingId, kind },
    })
    await unwrap<void>(res)
  },
}
